import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/content";
import { useReveal } from "../hooks/useReveal";

const Testimonials = () => {
    const [i, setI] = useState(0);
    const ref = useReveal();

    useEffect(() => {
        const id = setInterval(() => {
            setI((n) => (n + 1) % TESTIMONIALS.length);
        }, 7500);
        return () => clearInterval(id);
    }, []);

    const t = TESTIMONIALS[i];

    return (
        <section
            ref={ref}
            data-testid="testimonials-section"
            className="py-24 md:py-40 bg-samora-sand/40"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12">
                <div className="text-center mb-16 md:mb-20 reveal">
                    <p className="eyebrow mb-6">Client Notes</p>
                    <h2
                        className="font-display text-samora-ink leading-[0.95] tracking-tight"
                        style={{ fontSize: "clamp(2.5rem, 5.5vw, 5rem)" }}
                    >
                        Homes that speak<br />
                        <span className="italic font-serif text-samora-gold">
                            for themselves.
                        </span>
                    </h2>
                </div>

                <div className="max-w-4xl mx-auto text-center reveal">
                    <Quote
                        size={60}
                        strokeWidth={1}
                        className="text-samora-gold mx-auto mb-8"
                    />
                    <div key={i} className="animate-fade-up">
                        <p
                            data-testid="testimonial-quote"
                            className="font-serif italic text-samora-ink leading-[1.35]"
                            style={{
                                fontSize: "clamp(1.5rem, 3.4vw, 2.75rem)",
                            }}
                        >
                            "{t.quote}"
                        </p>
                        <div className="mt-10 hair-divider max-w-[80px] mx-auto" />
                        <p
                            data-testid="testimonial-author"
                            className="mt-6 font-display text-xl text-samora-ink"
                        >
                            {t.author}
                        </p>
                        <p className="mt-1 text-xs tracking-widest uppercase text-samora-mute">
                            {t.project}
                        </p>
                    </div>

                    <div className="mt-14 flex items-center justify-center gap-6">
                        <button
                            data-testid="testimonial-prev"
                            aria-label="Previous testimonial"
                            onClick={() =>
                                setI(
                                    (n) =>
                                        (n - 1 + TESTIMONIALS.length) %
                                        TESTIMONIALS.length
                                )
                            }
                            className="w-12 h-12 border border-samora-ink flex items-center justify-center text-samora-ink hover:bg-samora-ink hover:text-samora-bone transition-colors"
                        >
                            <ChevronLeft size={18} />
                        </button>
                        <span className="text-sm text-samora-mute tracking-widest">
                            {String(i + 1).padStart(2, "0")} /{" "}
                            {String(TESTIMONIALS.length).padStart(2, "0")}
                        </span>
                        <button
                            data-testid="testimonial-next"
                            aria-label="Next testimonial"
                            onClick={() =>
                                setI((n) => (n + 1) % TESTIMONIALS.length)
                            }
                            className="w-12 h-12 border border-samora-ink flex items-center justify-center text-samora-ink hover:bg-samora-ink hover:text-samora-bone transition-colors"
                        >
                            <ChevronRight size={18} />
                        </button>
                    </div>
                </div>

                {/* Google reviews placeholder */}
                <div className="mt-20 text-center reveal">
                    <div className="inline-flex items-center gap-3 px-6 py-4 border border-samora-ink/20 bg-samora-bone">
                        <span className="text-samora-gold text-2xl leading-none">
                            ★ ★ ★ ★ ★
                        </span>
                        <span className="text-sm text-samora-text/70">
                            5.0 · 42 Google reviews
                        </span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
